<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>口座入金報告明細</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div style="display: flex;">
            <div class="table-responsive">
                <div>
                    <table mat-table [dataSource]="dataSource" style="min-width: 330px;">
                        <ng-container matColumnDef="kouzaRcvmnyFclt">
                            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef
                                style="min-width: 150px;">
                                口座入金機関</th>
                            <td mat-cell *matCellDef="let row">{{row.kouzaRcvmnyFclt}}</td>
                        </ng-container>

                        <ng-container matColumnDef="kouzaRcvmnyDate">
                            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 75px;">
                                口座入金日</th>
                            <td mat-cell *matCellDef="let row">{{row.kouzaRcvmnyDate| dateString}}</td>
                        </ng-container>

                        <ng-container matColumnDef="kouzaRcvmnyAmt">
                            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef
                                style="min-width: 105px;">
                                口座入金額[円]</th>
                            <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.kouzaRcvmnyAmt | number}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCol;sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
                    </table>
                </div>
            </div>

            <mat-card-actions style="margin-left: 40px; margin-top: 10px;" class="account-button tw-content-end">
                <button type="button" mat-raised-button color="primary" class="btn"
                    [disabled]="isResistButtonDisabled()" (click)="onClickRegist()">金額登録</button>
            </mat-card-actions>

            <mat-card-actions style="margin-left: 40px; margin-top: 10px" class="account-button tw-content-end">
                <button type="button" mat-raised-button color="primary" class="btn" [disabled]="isEditButtonDisabled()"
                    (click)="onClickEdit()">金額訂正</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>